<div class="triton-activity-gauge">
    <div [chart]="chart"></div>
</div>
